module.exports = __webpack_public_path__ + "static/media/invoice_white.6f8da73b.svg";